var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full py-16 px-4"},[_c('h1',{staticClass:"md:text-3xl text-xl"},[_vm._v(" Kindly Click on the button in the bottom right corner of the page to start a chat with our support staff. Or contact us on "),_c('a',{staticClass:"text-blue-500",attrs:{"href":"mailto:hello@middey.com"}},[_vm._v("hello@middey.com")])])])
}]

export { render, staticRenderFns }